module.exports = __webpack_public_path__ + "img/nfe.89241ed9.svg";